// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__hyJm7","modalForm":"UpgradeEpcsModal_modalForm__326_L","modalFooter":"UpgradeEpcsModal_modalFooter__3XS_a"};